<div
  [ngClass]="widgetCssClassName()"
  [ngStyle]="{'top.px': topSearchSpacerHeight()}"
  class="places-dropdown-panel-overlay"
></div>
<div
  [class.fullscreen]="isFullscreen()"
  [ngClass]="widgetCssClassName()"
  [ngStyle]="{'top.px': topSearchSpacerHeight()}"
  class="places-dropdown-panel"
>
  <div class="places-dropdown-panel__header">
    <div class="places-dropdown-panel__top-container">
      @if (breadcrumbs().length === 0) {
        <div class="places-dropdown-panel__back">
          <div class="places-dropdown-panel__back__text">Alla län</div>
        </div>
      }

      @if (breadcrumbs().length === 1) {
        <div class="places-dropdown-panel__back">
          <div (click)="goBackTo(0)" class="places-dropdown-panel__back__link">Alla län</div>
          <app-ui-icon
            color="var(--grey-4)"
            name="chevron_right"
            size="sm"
          ></app-ui-icon>
          <div class="places-dropdown-panel__back__text">Kommun/Tätorter i {{ breadcrumbs()[0].name }}</div>
        </div>
      }

      @if (breadcrumbs().length > 1) {
        <div class="places-dropdown-panel__back">
          <div (click)="goBackTo(0)" class="places-dropdown-panel__back__link">Alla län</div>
          <app-ui-icon
            color="var(--grey-4)"
            name="chevron_right"
            size="sm"
          ></app-ui-icon>
          @if (isFullscreen()) {
            <div (click)="goBackTo(1)" class="places-dropdown-panel__back__link">...</div>
          } @else {
            <div
              (click)="goBackTo(1)"
              class="places-dropdown-panel__back__link"
            >Kommun/Tätorter i {{ breadcrumbs()[0].name }}
            </div>
          }
          <app-ui-icon
            color="var(--grey-4)"
            name="chevron_right"
            size="sm"
          ></app-ui-icon>
          <div class="places-dropdown-panel__back__text">Stadsdelar i {{ breadcrumbs()[1].name }}</div>
        </div>
      }


      <div class="places-dropdown-panel__close">
        <app-ui-icon
          (click)="onCloseClick()"
          color="var(--grey-4)"
          name="close"
          size="md"
        ></app-ui-icon>
      </div>
    </div>
  </div>
  <div class="places-dropdown-panel__body">
    @if (breadcrumbs().length > 0) {
      <div class="places-dropdown-panel__body__heading">
        @if (breadcrumbs().length === 1) {
          <div (click)="goBackTo(0)" class="link">
            <app-ui-icon color="var(--grey-4)" name="arrow_left" size="sm"></app-ui-icon>
            <span>Tillbaka till Alla län</span>
          </div>
        } @else {
          <div (click)="goBackTo(1)" class="link">
            <app-ui-icon color="var(--grey-4)" name="arrow_left" size="sm"></app-ui-icon>
            <span>Tillbaka till kommuner i {{ breadcrumbs()[0].name }}</span>
          </div>
        }
      </div>
    }


    <div class="row">
      @for (columnItem of columnHeaders(); let i = $index; track columnItem.header) {
        <div class="col">
          @for (listItem of columnItem.items; let j = $index; track listItem.id) {
            <div class="dropdown-list-item">
              @if (!listItem.hasChildren) {
                <div
                  [ngClass]="state().placeSearchValue === listItem.urlPath
                  ? elementToggleEnum.ACTIVE
                  : elementToggleEnum.NORMAL"
                  class="flex grow items-center gap-2"
                >
                  <div class="grow">
                    <div
                      (click)="onListItemClick(listItem.name)"
                      class="category__text"
                    >{{ listItem.name }}
                    </div
                    >
                  </div>
                  <div class="badge">{{ listItem.caregiverUnitsCount | filterCount }}</div>
                </div>
              }

              @if (listItem.hasChildren) {
                <div class="flex grow items-center gap-2">
                  <div class="grow">
                    <div
                      (click)="onListItemClick(listItem.name)"
                      class="category__text"
                    >{{ listItem.name }}
                    </div>
                  </div>
                  <div
                    (click)="loadChildren(listItem)"
                    [matTooltipClass]="'varden-tooltip'"
                    [matTooltipPosition]="'above'"
                    [matTooltip]="'Öppna underkategorier'"
                    class="info with-children"
                  >
                    <div class="badge">
                      {{ listItem.caregiverUnitsCount | filterCount }}
                    </div>
                    <app-ui-icon
                      class="chevron-right"
                      color="var(--green-1)"
                      name="chevron_right"
                      size="sm"
                    ></app-ui-icon>
                  </div>
                </div>
              }
            </div>
          }

        </div>
      }

      @if (!columnHeaders() || columnHeaders().length === 0) {
        <div class="col">
          <p>Laddar data...</p>
        </div>
      }
    </div>
    @if (includeFollowLinks()) {
      <div class="follow-links">
        @for (followItem of placesFollowLinks(); track followItem.id) {
          <a
            [queryParams]="followItem.queryParams"
            [routerLink]="followItem.routerLink"
            [title]="followItem.name"
          >
            {{ followItem.name }}
          </a>
        }
      </div>
    }

  </div>
</div>
